import styles from "./GameDropRow.module.css"
import LinkButton from "@/components/UI/Buttons/LinkButton/LinkButton"
import { useTranslations } from "next-intl"
import PEGI from "@/components/UI/PEGI/PEGI"
import { Row } from "@/interfaces/rows_types"
import { ImageKey } from "@/interfaces/genericTypes.types"
import Image from "next/image"
import { IMAGE_WIDTH_HORIZONTAL, IMAGE_WIDTH_VERTICAL } from "@/utils/constants"

export default function GameDropRow({ row }: { row: Row }) {
	const t = useTranslations('GameDropRow')
	const sizes = [400, 300, 200, 150, 133, 100, 75]
	const game = row.content[0]
	const background = row.background
	
	let bgSrc = null
	if(background && Object.keys(background).length > 0) {
		for (const size of sizes) {
		const key = `esc_${String(size).padStart(3, '0')}_url` as ImageKey
			if (background[key]) {
				bgSrc = background[key]
				break
			}
		}
	}

	const trailerSrc = process.env.NEXT_PUBLIC_ASSETS_ENDPOINT && game.trailer
    ? process.env.NEXT_PUBLIC_ASSETS_ENDPOINT + game.trailer
    : null
	
	return (
		<div className={styles.main}>
			{/* <img src={`${process.env.NEXT_PUBLIC_ASSETS_ENDPOINT + src }`} className={styles.backgroundImage}/> */}
			{trailerSrc && <video playsInline src={trailerSrc} autoPlay muted controls={false} loop className={styles.backgroundVideo} preload="none"/>}
			<Image className={styles.backgroundImage} alt={row.title} src={process.env.NEXT_PUBLIC_ASSETS_ENDPOINT + game.thumb_vertical?.esc_200_url!} width={IMAGE_WIDTH_HORIZONTAL} height={IMAGE_WIDTH_VERTICAL} />
			<div className={styles.content}>
				<h2 className={`${styles.title} title2`}>{row.title}</h2>
				<Image src={process.env.NEXT_PUBLIC_ASSETS_ENDPOINT +  row.icon} alt={row.title} className={styles.rowIcon} width={32} height={32}/>
				<h3>{game.title}</h3>
				<p>{game.description}</p>

				<div className={styles.pegiWrapper}>
					<span>{t('minAge')}</span>
					{row.content[0].min_age && <PEGI pegi={row.content[0].min_age} />}
				</div>

				<LinkButton className={styles.button} href={`/games/${game.game_id}`}>{t('viewMore')}</LinkButton>
			</div>
		</div>
	)
}